import wixSite from 'wix-site';
import {runProgressBar} from 'public/selectedPageHeader.js'; 


$w.onReady(function () 
{
    runProgressBar($w('#pageProgressBar'),1500);  
    $w('#pageNameText').text = wixSite.currentPage.name;
});
